import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-bir-exist-modal',
  templateUrl: './bir-exist-modal.component.html',
  styles: [
  ],
  standalone: false
})
export class BirExistModalComponent implements OnInit {

  visible = false;
  data: any = {};
  @Output() readonly selectBir: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
    return;
  }

  show(data: any) {
    this.data = data;
    this.visible = true;
  }

  concatString(stringValues: string[]) {
    return stringValues.filter(x => x).join(' ');
  }

  handleOk() {
    this.visible = false;
    this.selectBir.emit(this.data);
  }
}
